import { useState } from "react";
import { ImageOff } from "lucide-react";
import { cn } from "@/lib/utils";

interface SafeImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  fallbackClassName?: string;
  priority?: boolean;
}

export function SafeImage({ src, alt, className, fallbackClassName, priority, ...props }: SafeImageProps) {
  const [error, setError] = useState(false);

  if (!src || error) {
    return (
      <div className={cn("flex flex-col items-center justify-center bg-muted/50 text-muted-foreground p-4 text-center", className, fallbackClassName)}>
        <ImageOff className="h-6 w-6 opacity-40 mb-2" />
        <span className="text-[10px] font-medium uppercase tracking-wider mb-1">Image indisponible</span>
        {error && (
          <span className="text-[10px] opacity-60 leading-tight max-w-[200px]">
            Le lien fourni n'est pas une image directe valide, ou le serveur bloque l'acces.
          </span>
        )}
      </div>
    );
  }

  return (
    <img
      {...props}
      src={src}
      alt={alt || "Image"}
      loading={priority ? "eager" : "lazy"}
      decoding={priority ? "sync" : "async"}
      {...(priority ? { fetchPriority: "high" } : {})}
      onError={() => setError(true)}
      className={className}
    />
  );
}
